<template>
  <span>({{ count }}<span v-if="hidden" class="ontos-count-hidden">+{{ hidden }}</span>)</span>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

/**
 * O par "à vista + ocultos", como em `(3+2)`.
 *
 * Nasceu no cabeçalho da faixa do Kanban, para os itens que o prazo esconde. Saiu de lá
 * quando o botão de raias precisou do MESMO desenho: a classe do número menor morava num
 * `<style scoped>` e não alcançava outro componente, e copiar markup e CSS para repetir
 * uma convenção visual é como uma convenção visual se perde.
 *
 * O segundo número é menor e apagado de propósito: ele conta o que NÃO está sendo
 * mostrado, e não pode competir com o que está.
 */
@Component({name: 'ontos-count'})
class Count extends Vue {
  @Prop({type: Number, required: true}) readonly count!: number
  @Prop({type: Number, default: 0}) readonly hidden!: number
}

export default toNative(Count)
</script>

<style scoped>
.ontos-count-hidden {
  margin-left: 1px;
  font-size: 0.7em;
  font-weight: 400;
  opacity: 0.6;
}
</style>
